import React, { Children, useEffect, useRef, useState } from "react";
import FadeIn from "react-fade-in";
import {
  CrossIcon,
  EditPencilIcon,
  EditPencilIcon2,
  TableSortIconDownArrow,
} from "../../utils/icons/defaultIcons";
import TableTopBar from "../modal/tableTopBar";
import Table from "../../atom/table";
import Loader from "../loader";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PaginationButtons from "../../atom/pagination";
import { Backdrop, CircularProgress } from "@mui/material";
import Notification from "../../atom/Notification";
import Lottiefy from "../../atom/lottie/lottie";
import * as loaderLottie from "../../utils/lottie/loaderLottie.json";
import { setBreadcrumbs } from "../../toolkit/reducers/breadCrumbsSlice";
import ComponentMap from "../../atom/componentmap";
import ThemedButton from "../../atom/ThemedButton/themedButton";
import { add_New_DCID_Plan, get_NewPlan_Data } from "../../services/api";

function Add_Dcid_Plan() {
  const resRef = useRef<any[]>([]);
  const [manageState, setManageState] = useState<string>("");
  const [checkedAll, setCheckedAll] = useState<boolean>(false);
  // const [tableData, setTableData] = useState<any>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageCount, setPageCount] = useState<number>(0);
  const [perPage, setPerPage] = useState<number>(10000);
  const [resultNotFound, setResultNotFound] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [tableTitles, setTableTitles] = useState<any>([
    {
      key: "state",
      title: "State",
      icon: <TableSortIconDownArrow />,
      sort: { direction: "asc", active: true },
    },
    {
      key: "rate_center_display",
      title: "Rate Center",
      icon: <TableSortIconDownArrow />,
      sort: { direction: "asc", active: false },
    },
    {
      key: "npa",
      title: "NPA",
      icon: <TableSortIconDownArrow />,
      sort: { direction: "asc", active: false },
    },
    {
      key: "",
      type: "checkbox",
      classname: "float-right ",
      // column_select_hidden: false,
      selectAll: true,
    },
    // {
    //   key: "",
    //   // class: "text-center !w-[100px]",
    //   // title: "Call Info",
    //   type: "checkbox",
    //   selectAll: true,
    //   // hide: {
    //   //   status: true,
    //   //   default: true,
    //   // },
    // },
  ]);

  const [tableData, setTableData] = useState<any>([]);

  const [searchtext, setSearchText] = useState<any>("");
  const [sort, setSort] = useState<any>({
    key: "state",
    order: "ASC",
  });
  const [handleKeyPress, setHandleKeyPress] = useState<boolean>(true);

  const path = useLocation();

  const onHandleFetch: any = (options: {
    limit?: number;
    searchtext?: string;
    pageNumber?: number;
    sort_column?: string;
    sort_direction?: string;
  }) => {
    setLoader(true);
    let newsortkey =
      sort.key === "rate_center_display" ? "rate_center" : sort.key;

    get_NewPlan_Data({
      limit: options?.limit || perPage,
      pageId: options?.pageNumber || pageNumber,
      sort_column:
        options?.sort_column === "rate_center_display"
          ? "rate_center"
          : options?.sort_column || newsortkey,
      sort_direction: options?.sort_direction || sort.order,
      searchtext:
        options?.searchtext === undefined
          ? searchtext
          : options?.searchtext === ""
          ? ""
          : options?.searchtext,
    }).then((result: any) => {
      const plans = result?.data?.items || [];
      if (!result.success || plans.length === 0) {
        setLoader(false);
        setResultNotFound(true);
        setTableData([]);
        return;
      }
      setResultNotFound(false);

      const updatedPlans = plans.map((plan: any) => {
        const isSelected = resRef.current.some(
          (item: any) => item.uuid === plan.uuid
        );
        return { ...plan, checked: isSelected };
      });

      // ✅ determine if all visible rows are checked
      const allVisibleSelected =
        updatedPlans.length > 0 &&
        updatedPlans.every((row: any) => row.checked);

      const ttileCopy = [...tableTitles];
      const selectAllCol: any = ttileCopy.find((node: any) => node.selectAll);
      if (selectAllCol) selectAllCol.checked = allVisibleSelected;

      setCheckedAll(allVisibleSelected);
      setTableTitles(ttileCopy);
      setTableData(updatedPlans);
      setLoader(false);
      setPageCount(result?.data.total);
    });
  };

  const onHandleSort = (node: any, orderBy: string) => {
    setSort({ key: node.key, order: orderBy });
    onHandleFetch({ sort_column: node.key, sort_direction: orderBy });
  };

  // const selectAllCheckbox = (action: any, data: any) => {
  //   console.log("action", action, "data", data);
  //   const clone = [...tableData];
  //   const ttile = [...tableTitles];
  //   if (data?.selectAll === true) {
  //     const result: any = ttile.find((node: any) => {
  //       return node.key === data.key;
  //     });

  //     result.checked = !result?.checked || false;
  //     clone.map((node: any) => {
  //       node.checked = result?.checked;
  //     });
  //     setCheckedAll(result.checked);
  //   } else {
  //     setCheckedAll(false);

  //     const result = clone.find((node: any) => {
  //       return node.uuid === data.uuid;
  //     });

  //     result.checked = !result?.checked || false;
  //     const matched = tableData?.filter(
  //       (node: any) => node?.uuid === result.uuid
  //     );
  //     if (result?.checked) {
  //       resRef.current.push(...matched);
  //     } else {
  //       resRef.current = resRef.current.filter(
  //         (item: any) => item.uuid !== result.uuid
  //       );
  //     }
  //   }
  //   const result = clone.find((node: any) => {
  //     return node?.checked ? node?.checked : false;
  //   });

  //   setTableTitles(ttile);
  //   setTableData(clone);
  // };

  // selectAllCheckbox
  // const selectAllCheckbox = (action: any, data: any) => {
  //   const clone = [...tableData];
  //   const ttile = [...tableTitles];

  //   if (data?.selectAll === true) {
  //     // 🔹 Handle "Select All"
  //     const result: any = ttile.find((node: any) => node.key === data.key);

  //     result.checked = !result?.checked || false; // toggle
  //     clone.forEach((node: any) => {
  //       node.checked = result?.checked;
  //     });

  //     setCheckedAll(result.checked);
  //     resRef.current = result.checked ? [...clone] : []; // track all selected/unselected
  //   } else {
  //     // 🔹 Handle individual selection
  //     const row = clone.find((node: any) => node.uuid === data.uuid);

  //     if (row) {
  //       row.checked = !row?.checked || false;

  //       if (row.checked) {
  //         resRef.current.push(row);
  //       } else {
  //         resRef.current = resRef.current.filter(
  //           (item: any) => item.uuid !== row.uuid
  //         );
  //       }
  //     }

  //     // 🔹 Now check if ALL rows are selected
  //     const allSelected =
  //       clone.length > 0 && clone.every((node: any) => node.checked);
  //     const selectAllCol: any = ttile.find((node: any) => node.selectAll);

  //     if (selectAllCol) {
  //       selectAllCol.checked = allSelected;
  //     }

  //     setCheckedAll(allSelected);
  //   }

  //   setTableTitles(ttile);
  //   setTableData(clone);
  // };
  const selectAllCheckbox = (action: any, data: any) => {
    const clone = [...tableData]; // only visible rows
    const ttile = [...tableTitles];

    if (data?.selectAll === true) {
      const selectAllCol: any = ttile.find((node: any) => node.selectAll);
      const newChecked = !selectAllCol?.checked;

      clone.forEach((row: any) => (row.checked = newChecked));

      if (newChecked) {
        resRef.current = [
          ...resRef.current.filter(
            (old) => !clone.some((row) => row.uuid === old.uuid)
          ),
          ...clone,
        ];
      } else {
        resRef.current = resRef.current.filter(
          (old) => !clone.some((row) => row.uuid === old.uuid)
        );
      }

      selectAllCol.checked = newChecked;
      setCheckedAll(newChecked);
    } else {
      const row = clone.find((node: any) => node.uuid === data.uuid);
      if (row) {
        row.checked = !row.checked;
        if (row.checked) {
          if (!resRef.current.some((item) => item.uuid === row.uuid)) {
            resRef.current.push(row);
          }
        } else {
          resRef.current = resRef.current.filter(
            (item) => item.uuid !== row.uuid
          );
        }
      }

      // ✅ recalc selectAll only for visible rows
      const allVisibleSelected =
        clone.length > 0 && clone.every((row) => row.checked);
      const selectAllCol: any = ttile.find((node: any) => node.selectAll);
      if (selectAllCol) selectAllCol.checked = allVisibleSelected;
      setCheckedAll(allVisibleSelected);
    }

    setTableTitles(ttile);
    setTableData(clone);
  };

  const get_DCID_TableData = (pgNum: number) => {
    setPageNumber(pgNum);
    onHandleFetch({ pageNumber: pgNum });
  };

  // this function handles every button clicks for navigation :)
  const onhandleStateChange = (state: any, data: any) => {
    if (state === "Rate Center") {
      state = "ratecenter";
    }
    navigate(`${state}`, { replace: false });
  };

  const actionHandler = (action: string, data: any, index: number) => {
    const actionsMap: any = {
      "Rate Center": onhandleStateChange,
      selectall: selectAllCheckbox,
      change: selectAllCheckbox,
    };
    const act = actionsMap[action];
    if (act) {
      act(action, data);
    } else {
      console.log("actionHandler Error");
    }
  };

  // let data: any = { name: "", dids_per_npa: "" };
  const [data, setData] = useState<any>({ name: "", dids_per_npa: 0 });
  const handle_Textbox_Event = (e: any, item: any) => {
    const value = e.target.value;

    if (item === "dids") {
      const numValue = parseInt(value);

      //  If input is empty or invalid, set to 0
      if (value === "" || isNaN(numValue)) {
        setData((prevData: any) => ({
          ...prevData,
          dids_per_npa: 0,
        }));
        return;
      }

      //  If value is valid and >= 1
      if (numValue >= 1) {
        setData((prevData: any) => ({
          ...prevData,
          dids_per_npa: numValue,
        }));
      }
    } else if (item === "planName") {
      setData((prevData: any) => ({
        ...prevData,
        name: value,
      }));
    }
  };

  const onHandleSubmit = () => {
    setLoader(true);
    const npaIds = resRef.current.map((node: any) => {
      return node?.uuid;
    });

    let payload: any = {
      npa_ids: npaIds,
      dids_per_npa: data.dids_per_npa,
      name: data.name,
    };
    console.log("data.dids_per_npa", data.dids_per_npa, data.name);
    const nameEmpty = !data.name?.trim();
    const didsPerNpa = Number(data.dids_per_npa);
    const didsInvalid = isNaN(didsPerNpa) || didsPerNpa < 1;
    const noNpaSelected = !npaIds.length;
    console.log("didsPerNpa", didsPerNpa);
    if (nameEmpty || isNaN(didsPerNpa)) {
      Notification("Failed", "Please fill all fields", "danger");
      setLoader(false);
    } else if (didsInvalid) {
      Notification("Failed", "Minimum DIDs per NPA must be 1", "danger");
      setLoader(false);
    } else if (noNpaSelected) {
      Notification("Failed", "No NPA's selected", "danger");
      setLoader(false);
    } else {
      add_New_DCID_Plan(payload).then((result: any) => {
        setLoader(true);

        if (!result.success) {
          setLoader(false);
          Notification(
            "Failed",
            `${
              result?.message
                ? result?.message
                : "Oops! Something went wrong. Please try again later"
            }`,
            "danger"
          );
        } else {
          Notification("Success", "Plan added successfully", "success");
          setLoader(false);
          // navigate(-1);
          navigate(`/app/dcid`, { replace: false });
        }
      });
    }
  };

  const handlePerPage = (value: any) => {
    console.log("perpage value", value);
    value = parseInt(value);
    setPerPage(value);
    setPageNumber(1);
    onHandleFetch({ limit: value, pageNumber: 1 });
  };

  const handleChange = (pgNum: number) => {
    get_DCID_TableData(pgNum);
    setPageNumber(pgNum);
  };

  const onHandleCancel = () => {
    navigate(`/app/dcid`, { replace: false });
  };
  const handleSearch = (data: string) => {
    setPageNumber(1);
    setSearchText(data);
    onHandleFetch({ searchtext: data, pageNumber: 1, limit: perPage });
  };

  useEffect(() => {
    get_DCID_TableData(1);
  }, []);

  return (
    <div>
      <div className="h-full py-3 flex relative  rounded-md">
        <Backdrop className="!z-[99999999999]" open={loader}>
          <Lottiefy loop={true} json={loaderLottie} height={100} width={100} />
        </Backdrop>
        <div
          className={`h-[calc(100vh-125px)] w-full  overflow-x-auto overflow-y-hidden  rounded-md bg-[#fff]`}
        >
          <FadeIn>
            <div className="pt-3">
              <TableTopBar
                title={"New DCID Plan"}
                button={true}
                manageState={manageState}
                setManageState={setManageState}
                onhandleStateChange={onhandleStateChange}
                permission={"provision.users.post"}
                buttonText={"Rate Center"}
                search={true}
                searchtext={searchtext}
                setSearchText={setSearchText}
                handleKeyPress={handleKeyPress}
                handleSearch={handleSearch}
                CSV={false}
                setHandleKeyPress={setHandleKeyPress}
                actionHandler={actionHandler}
              />
            </div>

            <div className="p-2 ">
              <div className="flex p-2 gap-x-[68px] ">
                <label className="text-[#7c7c7c] font-semibold text-[16px] items-center flex">
                  Plan Name
                </label>
                <input
                  type="text"
                  id="plan_name_textbox"
                  className="border border-[#696969] rounded p-2 w-[340px] focus:outline-none "
                  onChange={(e) => handle_Textbox_Event(e, "planName")}
                />
              </div>

              <div className="flex p-2 gap-x-[48px] ">
                <label className="text-[#7c7c7c] font-semibold text-[16px] items-center flex">
                  DIDs per NPA
                </label>
                <input
                  type="number"
                  id="dids_per_npa_textbox"
                  min="0"
                  className="border border-[#696969] rounded p-2 w-[340px] focus:outline-none"
                  onChange={(e) => handle_Textbox_Event(e, "dids")}
                  onInput={(e: any) => {
                    if (e.target.value < 1) e.target.value = ""; // Reset if typed 0 or -
                  }}
                />
              </div>
              <div className="flex"></div>
            </div>
            <div className="h-[calc(100vh-500px)]">
              <Table
                tableTitles={tableTitles}
                tableData={tableData}
                setTableData={setTableData}
                actionHandler={actionHandler}
                setTableTitles={setTableTitles}
                button={true}
                buttonIndex={4}
                buttonText1={"manage"}
                width={"w-[calc(100vw-122px)] overflow-auto"}
                scrollHeight={"h-[calc(100vh-480px)] overflow-y-auto"}
                manageState={manageState}
                setManageState={setManageState}
                onHandleSort={onHandleSort}
                onhandleStateChange={onhandleStateChange}
                permission={"provision.users.put"}
                actions={true}
                resultNotFound={resultNotFound}
              />
            </div>

            <div className=" h-full py-4 px-3 flex  mt-2 float-right">
              <ThemedButton
                children={"Cancel"}
                icon="custom"
                theme="secondary"
                // valiData={callReport}
                // change={setCallReport}
                click={onHandleCancel}
              />
              <ThemedButton
                children={"Submit"}
                icon="custom"
                theme="primary"
                click={() => {
                  onHandleSubmit();
                }}
                // valiData={tableData}
                // change={setTableData}
                // click={onHandleUpdate}
                // loading={buttonLoader}
              />
            </div>

            {!resultNotFound && tableData.length > 0 && (
              <PaginationButtons
                pageNumber={pageNumber}
                handleChange={handleChange}
                pageCount={pageCount}
                perPage={perPage}
                handlePerPage={handlePerPage}
                enableAll={true}
                hideLimit={true}
              />
            )}
          </FadeIn>
        </div>
      </div>
    </div>
  );
}

export default Add_Dcid_Plan;
